import { SxProps, Theme } from '@mui/material';
import { appZIndex } from '../../../../styles/zIndex';

export const moduleDrawerStyles: Record<string, SxProps<Theme>> = {
  drawerRoot: {
    zIndex: appZIndex.drawer,
    '& .MuiDrawer-paper': {
      top: 'var(--menu-bar-height)',
      height: 'calc(100% - var(--menu-bar-height))',
      borderTopLeftRadius: '8px',
      border: '1px solid var(--border-color)',
    },
  },
  container: {
    width: { xs: '100vw', sm: 420, md: 480 },
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: 2,
    borderBottom: '1px solid var(--border-color)',
    position: 'sticky',
    top: 0,
    bgcolor: 'background.paper',
    zIndex: appZIndex.base,
  },
  title: { fontWeight: 600, fontSize: '1rem' },
  content: { flex: 1, overflowY: 'auto', px: 2, py: 1 },
};
